<template>
  <validation-provider
    #default="{ errors }"
    name="Limit"
    rules="required"
  >
    <b-input-group :append="itemData.package_limits[iKey].param_text">
      <cleave
        id="limits"
        v-model="itemData.package_limits[iKey].limit"
        class="form-control"
        :raw="true"
        :options="options.limit"
        placeholder="Giriniz"
        :disabled="itemData.package_limits[iKey].disabled === '1'"
      />
    </b-input-group>
    <small class="text-danger">{{ errors[0] }}</small>
  </validation-provider>
</template>

<script>
import { ValidationProvider } from 'vee-validate'
import Cleave from 'vue-cleave-component'
import { BInputGroup } from 'bootstrap-vue'

export default {
  name: 'PackageLimitNumberInputCard',
  components: {
    Cleave,
    ValidationProvider,
    BInputGroup,
  },
  props: {
    iKey: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      options: {
        limit: {
          numeral: true,
        },
      },
    }
  },
  computed: {
    itemData() {
      return this.$store.getters['projectPackages/dataItem']
    },
  },
}
</script>
